// components/RoleGuard.jsx
import { Navigate } from "react-router-dom";

const RoleGuard = ({ allowedRoles, children }) => {
  var userRole = sessionStorage.getItem("role");
  if (!allowedRoles.includes(userRole)) {
    console.log(allowedRoles[0] + " - - " + userRole);
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

// requireAll defaults to false, so every existing route keeps its "any of these
// roles" behaviour. Pass requireAll when a route needs all of them, e.g. the master
// data request reviewer, who must have IsAdmin *and* the Coordinator role.
const UserRoleGuard = ({ allowedRoles, requireAll = false, children }) => {
  var userRole = (sessionStorage.getItem("userrole") || '')
    .split(',')
    .map(role => role.trim())
    .filter(Boolean);

  const isAllowed = requireAll
    ? allowedRoles.every(role => userRole.includes(role))
    : userRole.some(role => allowedRoles.includes(role));

  if (!isAllowed) {
    console.log(allowedRoles[0] + " - - " + userRole);
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export { RoleGuard, UserRoleGuard };
